import { restService } from "./RestService";

export class ConfigService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    async getConfig() {
        const url = `${this.baseUrl}/config`;

        try {
            return await restService.get(url);
        } catch (error) {
            this.handleError(error, 'Unable to load property configuration - please see server logs for more details');
        }
    }

    handleError = (error, message) => {
        throw new Error(message, { cause: error });
    }
}
